import { AxiosResponse } from 'axios';

import { instance as axios } from '../../api/axios';
import { SecurityGate } from './interfaces';

export class SecurityGateService {
  public static async getSGates(params: any) {
    try {
      const url = `/SecurityGate`;
      const response: AxiosResponse<SecurityGate[]> = await axios.get(url, { params });

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }
}
